/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type CarpsaleManagementEditItemRequest = {
    id: number;
    categoryId: number;
    subCategoryId?: number;
    code: string;
    type: string;
    language: string;
    name: string;
    nameEn?: string;
    nameCn?: string;
    optioNames?: string;
    optioNamesEn?: string;
    optioNamesCn?: string;
    company?: string;
    companyEn?: string;
    companyCn?: string;
    kind?: string;
    kindEn?: string;
    kindCn?: string;
    sex: CarpsaleManagementEditItemRequest.sex;
    isPrice?: boolean;
    price?: number;
    salePrice?: number;
    isQuantity?: boolean;
    quantity?: number;
    size?: number;
    sendType?: CarpsaleManagementEditItemRequest.sendType;
    context?: string;
    contextEn?: string;
    contextCn?: string;
    startSaleDatetime?: string;
    openStatus?: CarpsaleManagementEditItemRequest.openStatus;
    releaseSetting?: CarpsaleManagementEditItemRequest.releaseSetting;
    postDate?: string;
    saleId?: number;
    saleCode?: string;
    startDate?: string;
    endDate?: string;
};

export namespace CarpsaleManagementEditItemRequest {

    export enum sex {
        MALE = 'male',
        FEMALE = 'female',
        UNKNOWN = 'unknown',
        FEMALE_NOW = 'female_now',
    }

    export enum sendType {
        SINGLE = 'Single',
        MULTI = 'Multi',
    }

    export enum openStatus {
        HOLD = 'hold',
        RELEASE = 'release',
        NO_RELEASE = 'no_release',
    }

    export enum releaseSetting {
        NOW = 'now',
        DATE = 'date',
    }


}

